import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const popblock = {
  fetchPopblock: lazyModuleMethod(() => import('./fetchPopblock'), 'default'),
  fetchPopblocks: lazyModuleMethod(() => import('./fetchPopblocks'), 'default'),
  createPopblock: lazyModuleMethod(() => import('./createPopblock'), 'default'),
  editPopblock: lazyModuleMethod(() => import('./editPopblock'), 'default'),
  deletePopblock: lazyModuleMethod(() => import('./deletePopblock'), 'default'),
  removePopblock: lazyModuleMethod(() => import('./removePopblock'), 'default'),
}
